// Modules
import { useDispatch, useSelector } from "react-redux";
import { Box, Button, Grid, useTheme } from "@mui/material";
import type { RootState } from "../../types/store";
import AppActions from "../../actions/app-actions";
import Header from "../../components/ui-header";
import TeamContainer from "../../components/team/team-container";
import GameInfo from "../../components/game-info-container";
import UIError from "../../components/ui-error";
//import { useEffect, useState } from "react";

export default function Lobby() {
    const dispatch = useDispatch();
    const lobby = useSelector((state: RootState) => state.page.lobby);
    const translate = useSelector(
        (state: RootState) => state.ui.language.lobby
    );
    const theme = useTheme();
    const isTV = !lobby.playing;


    function onStart() {
        dispatch(AppActions.GameStart({ code: lobby.code }));
    }
    function onLeave() {
        dispatch(AppActions.LeaveLobby());
    }
    function onKick(nickname: string) {
        if (lobby.admin) dispatch(AppActions.Kick({ nickname: nickname }));
    }

    return (
        <Box sx={isTV ? {
            height: '100dvh',
            display: 'flex',
            flexDirection: 'column',
            overflowY: 'auto',
            scrollbarWidth: 'thin',
            scrollbarColor: '#7dabd0ff rgba(255,255,255,0.1)',
            '&::-webkit-scrollbar': { width: '8px' },
            '&::-webkit-scrollbar-thumb': { background: '#7dabd0ff', borderRadius: '4px' },
            '&::-webkit-scrollbar-track': { background: 'rgba(255,255,255,0.1)' },
        } : undefined}>

            <Box
                boxShadow={"2px 2px 2px 2px rgb(0,0,0,0.1)"}
                height={isTV ? "auto" : "6rem"}
                bgcolor={theme.palette.secondary.dark}
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
                flexShrink={0}
                padding={isTV ? 1 : 0}
            >
                <Header size={isTV ? "md" : "lg"} text={`LOBBY CODE ${lobby.code}`} />
            </Box>

            <Grid
                container
                marginTop={isTV ? 1 : 4}
                gap={isTV ? 1.5 : 2}
                display={"flex"}
                justifyContent={"center"}
                sx={isTV ? {
                    flex: 1,
                    minHeight: 0,
                    overflowY: 'auto',
                    scrollbarWidth: 'thin',
                    scrollbarColor: '#7dabd0ff rgba(255,255,255,0.1)',
                    px: { xs: 1, md: 2 },
                    pb: 1,
                } : undefined}
            >
                <Grid size={{ xs: 11, md: 11, lg: 7, xl: 7 }}
                    sx={isTV ? {
                        display: 'flex',
                        flexDirection: 'column',
                        minHeight: 0,
                    } : undefined}
                >
                    <TeamContainer
                        isAdmin={lobby.admin}
                        onKick={onKick}
                        players={lobby.players}
                        me={lobby.nickname}
                    />
                </Grid>

                <Grid size={{ xs: 11, md: 11, lg: 4.5, xl: 4.5 }}
                    sx={isTV ? {
                        display: 'flex',
                        flexDirection: 'column',
                        minHeight: 0,
                    } : undefined}
                >
                    <GameInfo sx={isTV ? {} : { display: { xs: "none", lg: "block" } }} />

                    {lobby.error && (
                        <Grid
                            container
                            marginTop={2}
                            gap={2}
                            display={"flex"}
                            justifyContent={"center"}
                        >
                            <Grid size={{ xs: 12, md: 8 }}>
                                <UIError message={lobby.error} />
                            </Grid>
                        </Grid>
                    )}

                    <Grid
                        container
                        marginTop={2}
                        marginBottom={2}
                        gap={2}
                        display={"flex"}
                        justifyContent={"center"}
                    >
                        <Grid size={{ xs: 5, sm: 4, md: 'auto' }}>
                            <Button
                                color="error"
                                variant="contained"
                                onClick={onLeave}
                                sx={{ minWidth: 120 }}
                            >
                                {translate.leaveLobby}
                            </Button>
                        </Grid>

                        {lobby.admin && (
                            <Grid size={{ xs: 5, sm: 4, md: 'auto' }}>
                                <Button
                                    color="secondary"
                                    variant="contained"
                                    onClick={onStart}
                                    sx={{ minWidth: 120 }}
                                >
                                    {translate.start}
                                </Button>
                            </Grid>
                        )}
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
}
